import React from 'react';

interface SidebarSkeletonProps {
  itemCount?: number;
}

const SidebarSkeleton: React.FC<SidebarSkeletonProps> = ({ itemCount = 8 }) => {
  return (
    <div className="sidebar-skeleton-container">
      {Array.from({ length: itemCount }).map((_, index) => (
        <div key={index} className="sidebar-skeleton-item">
          <div className="sidebar-skeleton-icon"></div>
          <div className="sidebar-skeleton-text"></div>
        </div>
      ))}
    </div>
  );
};

export default SidebarSkeleton;
